import { render, staticRenderFns } from "./MRC_ESS_selectColor.vue?vue&type=template&id=5174b10c&"
import script from "./MRC_ESS_selectColor.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_selectColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VContainer,VHover,VMenu,VSelect,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5174b10c')) {
      api.createRecord('5174b10c', component.options)
    } else {
      api.reload('5174b10c', component.options)
    }
    module.hot.accept("./MRC_ESS_selectColor.vue?vue&type=template&id=5174b10c&", function () {
      api.rerender('5174b10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_selectColor.vue"
export default component.exports